import RunningExperimentsService from 'experiments/experiments-service';
import {HOW_IT_WORKS_SECTION, HOW_IT_WORKS_SECTION_VARIATION} from 'experiments/experiments-service.constants';

export const isInHowItWorksExp = () => {
    return RunningExperimentsService.isInExperimentBucket(HOW_IT_WORKS_SECTION, HOW_IT_WORKS_SECTION_VARIATION);
};
